import { theme } from '@ublend-npm/aulaui-next';

export const textColours = {
  Default: theme.color.designSystem.blackOpacity87,
  Grey: theme.color.designSystem.blackOpacity60,
  Purple: theme.color.designSystem.textColors.purple,
  Blue: theme.color.designSystem.textColors.blue,
  Green: theme.color.designSystem.textColors.green,
  Orange: theme.color.designSystem.textColors.orange,
  Red: theme.color.designSystem.textColors.red,
};

export type TextColourKey = keyof typeof textColours;
